import { render, staticRenderFns } from "./CompanyTaxation.vue?vue&type=template&id=7f1be9f9&"
import script from "./CompanyTaxation.vue?vue&type=script&lang=js&"
export * from "./CompanyTaxation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports